import { createFileRoute } from "@tanstack/react-router";
import { getLegalPages } from "@/lib/legal.functions";
import { LegalPageView, legalMeta } from "@/components/site/legal/LegalPage";

export const Route = createFileRoute("/cookies")({
  loader: () => getLegalPages({ data: { lang: "es" } }),
  head: ({ loaderData }) =>
    loaderData
      ? legalMeta(loaderData.pages.cookies, "/cookies")
      : { meta: [{ title: "Política de Cookies — Bizaclia.com" }] },
  component: CookiesPage,
});

function CookiesPage() {
  const data = Route.useLoaderData();
  return <LegalPageView page={data.pages.cookies} operator={data.operator} />;
}
